const onboarding = {
  title: "مرحبا بك في",
  titleHighlight: "يُرام",
  description:
    "اعرض وأدر وتتبع جميع الأحداث المجدولة بسهولة في لوحة تحكم مركزية واحدة، مصممة لتمنحك وضوحًا وتحكماً فوريًا في عملياتك.",
  getStarted: "ابدأ",
};

export default onboarding;
